import { Box } from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { AbsenceEntry } from '~/data/absences/types';
import { Legend } from '~/scenes/MyWorkspace/components/Widgets/components/MyTeamAbsencesWidget/components/Legend';
import { useAbsencesCalendarData } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/AbsencesCalendar/useAbsencesCalendarData';

import { CalendarHeader } from './components/CalendarHeader';
import { CalendarRows } from './components/CalendarRows';
import { useAbsenceCalendar } from './useAbsenceCalendar';
import { useSxStyles } from './useStyles';

export interface AbsencesCalendarProps {
  employeeId: number;
  absenceEntries: AbsenceEntry[];
  containerWidth: number;
  shouldRedirect: boolean;
}

export const AbsencesCalendar: React.FC<AbsencesCalendarProps> = (
  props: AbsencesCalendarProps,
) => {
  const { absenceEntries, employeeId, containerWidth, shouldRedirect } = props;

  const { teamAbsences, publicHolidays, targetEmployee } =
    useAbsencesCalendarData({ absenceEntries, employeeId });

  const { viewStartDate, daysInView, handleCalendarNavigation, containerRef } =
    useAbsenceCalendar();
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const minSizeRender = containerWidth < 400;

  const endOfRange = moment().add(90, 'days');

  return (
    <>
      <Box sx={sxStyles.contentWrapper}>
        <Box sx={sxStyles.calendarHeaderWrapper}>
          <Box sx={minSizeRender ? sxStyles.minLeftCell : sxStyles.leftCells}>
            {t('name')}
          </Box>
          <Box ref={containerRef} sx={sxStyles.rightCells}>
            <CalendarHeader
              viewStartDate={viewStartDate}
              daysInView={daysInView}
              handleCalendarNavigation={handleCalendarNavigation}
              endOfRange={endOfRange}
            />
          </Box>
        </Box>
        <Box sx={sxStyles.tableWrapper}>
          <CalendarRows
            minSizeRender={minSizeRender}
            teamAbsences={teamAbsences}
            publicHolidays={publicHolidays}
            daysInView={daysInView}
            endOfRange={endOfRange}
            shouldRedirect={shouldRedirect}
            targetEmployee={targetEmployee}
          />
        </Box>
      </Box>
      <Box>
        <Legend teamAbsences={teamAbsences} />
      </Box>
    </>
  );
};
